// @todo: Translations

const SOLR_SEARCH_REST_CONFIG_PARTICIPANTS = {
  endpoint: `/api/search/participants`,
  pageMode: "endless", // endless or pager or none
  search: true,
  fields: [],
  facets: [
    {
      id: "participants_first_letter",
      label: "First Letter",
      type: "scroll_to",
    }
  ],
  presetFilters: [],
  pagerSize: 9,
};

export default SOLR_SEARCH_REST_CONFIG_PARTICIPANTS;
